import { signalStore } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { Phase } from '../../processus-phases/models/phase.model';
import { avecMéthodesPhases } from './phase.methods';

export const PhaseStore = signalStore({ providedIn: 'root' }, withEntities<Phase>(), avecMéthodesPhases());
